import React, { PureComponent, ReactNode } from 'react';
import Select, { OptionsType, ValueType, OptionTypeBase, MouseEventHandler } from 'react-select';
import isEqual from 'lodash/isEqual';
import { snakeCase } from 'lodash';

// components
import { AnalyticsComponent, AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { customStyles } from './customMultiselectStyles';

interface OwnProps extends AnalyticsProps {
  options?: OptionsType<any>;
  isLoading?: boolean;
  selectedData?: Array<any>;
  onChange?: (value: any) => any;
  onClick?: MouseEventHandler;
  name: string;
  placeholder: string;
  isReadOnly?: boolean;
}

interface State {
  selectedValues: Array<OptionTypeBase>;
}

type Props = OwnProps;

export default class Multiselect extends PureComponent<Props, State> {
  static defaultProps = { isReadOnly: false };

  state = { selectedValues: [] };

  componentDidMount() {
    const { selectedData } = this.props;

    if (selectedData) {
      this.setState({
        selectedValues: selectedData,
      });
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { selectedData } = this.props;
    const { selectedData: prevSelectedOptions } = prevProps;

    if (selectedData && !isEqual(selectedData, prevSelectedOptions)) {
      this.setState({ selectedValues: selectedData });
    }
  }

  handleSelectChange = (selectedValues: ValueType<any>) => {
    const { onChange } = this.props;

    if (!selectedValues) {
      this.setState({
        selectedValues: [],
      });

      if (onChange) {
        onChange([]); // emit change
      }

      return;
    }
    this.setState({ selectedValues });

    if (onChange) {
      onChange(selectedValues); // emit change
    }
  };

  getSelectedValues = () => {
    const { selectedValues } = this.state as State;
    const selectedValue = selectedValues.map((item: OptionTypeBase) => item.value);

    return selectedValue;
  };

  getSelectedOptions = () => {
    const { selectedValues } = this.state as State;
    return selectedValues;
  };

  render(): ReactNode {
    const { selectedValues } = this.state;
    const { options, name, placeholder, isLoading, isReadOnly = false, tag = '' } = this.props;

    return (
      <AnalyticsComponent>
        {({ pages, tracker, merchantId: analyticsMerchantId, ip }) => (
          <Select
            onMenuOpen={() =>
              tracker.track({
                event: 'dropdown_select',
                type: 'dropdown',
                tag,
                pages,
                merchantId: analyticsMerchantId,
                ip,
              })
            }
            isMulti
            name={name}
            placeholder={placeholder}
            value={selectedValues}
            options={options}
            onChange={(values: ValueType<any>) => {
              tracker.track({
                event: 'dropdown_change',
                type: 'dropdown',
                tag: values?.map((val: any) => `${tag}_${snakeCase(val.label)}`).join(',') || `${tag}_empty`,
                pages,
                merchantId: analyticsMerchantId,
                ip,
              });
              return this.handleSelectChange(values);
            }}
            isLoading={isLoading}
            isDisabled={isReadOnly}
            styles={customStyles}
            // This prop is needed to prevent the select options dropdown to go under the modal
            menuPortalTarget={document.body}
          />
        )}
      </AnalyticsComponent>
    );
  }
}
